import EncounterDetailsBilling from './EncounterDetailsBilling';

export default EncounterDetailsBilling;
